import state from './users.state'
import mutations from './users.mutations'
import actions from './users.actions'
import getters from './users.getters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
